export type InfinityStoneId =
  | 'power'
  | 'mind'
  | 'reality'
  | 'space'
  | 'time'
  | 'soul'
  | 'morphin-blast'
  | 'zord-strike';

export const INFINITY_STONE_ORDER: InfinityStoneId[] = [
  'power',
  'mind',
  'reality',
  'space',
  'time',
  'soul',
  'morphin-blast',
  'zord-strike',
];

export type StoneSpec = {
  id: InfinityStoneId;
  name: string;
  label: string;
  color: number;
  flash: [number, number, number];
  tagline: string;
};

export const STONES: Record<InfinityStoneId, StoneSpec> = {
  power: {
    id: 'power',
    name: 'Power Stone',
    label: 'POWER!',
    color: 0x9333ea,
    flash: [147, 51, 234],
    tagline: 'Clears the center + 10 damage',
  },
  mind: {
    id: 'mind',
    name: 'Mind Stone',
    label: 'MIND CONTROL!',
    color: 0xfacc15,
    flash: [250, 204, 21],
    tagline: 'Next 3 enemy attacks clear the board',
  },
  reality: {
    id: 'reality',
    name: 'Reality Stone',
    label: 'REALITY WARP!',
    color: 0xef4444,
    flash: [239, 68, 68],
    tagline: 'Board rebuilds with hero tiles only',
  },
  space: {
    id: 'space',
    name: 'Space Stone',
    label: 'DIMENSIONAL TEAR!',
    color: 0x3b82f6,
    flash: [59, 130, 246],
    tagline: '15 damage + skip 3 attacks',
  },
  time: {
    id: 'time',
    name: 'Time Stone',
    label: 'TIME REVERSAL!',
    color: 0x22c55e,
    flash: [34, 197, 94],
    tagline: 'Fully restore hero HP',
  },
  soul: {
    id: 'soul',
    name: 'Soul Stone',
    label: 'SOUL EXCHANGE!',
    color: 0xf97316,
    flash: [249, 115, 22],
    tagline: 'All hero powers fully charged',
  },
  'morphin-blast': {
    id: 'morphin-blast',
    name: 'Morphin Blast',
    label: 'MORPHIN BLAST!',
    color: 0xef4444,
    flash: [239, 68, 68],
    tagline: 'Blow the whole top row off the board',
  },
  'zord-strike': {
    id: 'zord-strike',
    name: 'Zord Strike',
    label: 'ZORD STRIKE!',
    color: 0x22c55e,
    flash: [34, 197, 94],
    tagline: '18 damage + clear a diagonal sweep',
  },
};

export const BOSS_STONE_DROPS: Record<string, InfinityStoneId> = {
  'w2-boss': 'mind',
  'w4-boss': 'soul',
  'w6-boss': 'time',
  'w8-boss': 'power',
  'w10-boss': 'morphin-blast',
  'w12-boss': 'zord-strike',
  'w13-boss': 'space',
  'w14-boss': 'reality',
};

export const BOSS_VIBRANIUM_DROPS: Record<string, number> = {
  'w1-boss': 5,
  'w3-boss': 5,
  'w5-boss': 5,
  'w7-boss': 5,
  'w9-boss': 5,
};

export const BOSS_MORPHIN_GRID_DROPS: Record<string, number> = {
  'w11-boss': 5,
};
